import { useContext } from "react"
import { LoaderContext, NotificationContext, UserContext } from "../context"
import { update_agency } from "../services/firestore"

const useAgencyActions = () => {

  const { agency, user, setAgency, entityId, clusterId, softId, brandId } = useContext(UserContext)
  const { setNotification } = useContext(NotificationContext)
  const { setShowGlobalResponseLoader } = useContext(LoaderContext)

  const isTemplateValidationRequired = (templateId) => {
    return agency?.validation_required_templates?.includes(templateId)
  }

  const toggleTemplateValidationRequirement = async (templateId) => {
    if (user?.validation_access !== 'manager') {
      setNotification({ msg: 'Vous n\'avez pas les droits pour effectuer cette action.', type: 'error' })
      return
    }
    if (!agency) {
      setNotification({ msg: 'Aucune agence associée.', type: 'error' })
      return
    }

    let updatedTemplates = [...(agency.validation_required_templates || [])]

    if (updatedTemplates.includes(templateId)) {
      // remove
      updatedTemplates = updatedTemplates.filter(id => id !== templateId)
    } else {
      // add
      updatedTemplates.push(templateId)
    }

    await updateAgency({
      validation_required_templates: updatedTemplates.filter(templateId => Boolean(templateId))
    })
  }

  const setTemplatesValidationRequired = async (templateIds, required) => {
    if (user?.validation_access !== 'manager') {
      setNotification({ msg: 'Vous n\'avez pas les droits pour effectuer cette action.', type: 'error' })
      return
    }
    if (!agency) {
      setNotification({ msg: 'Aucune agence associée.', type: 'error' })
      return
    }

    let updatedTemplates = [...(agency.validation_required_templates || [])]
    templateIds.forEach(templateId => {
      if (required) {
        // add
        if (!updatedTemplates.includes(templateId)) {
          updatedTemplates.push(templateId)
        }
      } else {
        // remove
        updatedTemplates = updatedTemplates.filter(id => id !== templateId)
      }
    })
    
    await updateAgency({
      validation_required_templates: updatedTemplates.filter(templateId => Boolean(templateId))
    })
  }

  const updateAgency = async (updates) => {
    if (!agency) {
      setNotification({ msg: 'Aucune agence associée.', type: 'error' })
      return
    }
    
    updates.metadata = {
      brandId,
      clusterId,
      entityId,
      softId,
      ...agency.metadata,
    }
    
    setShowGlobalResponseLoader(true)

    const updatedAgencyResponse = await update_agency(entityId, updates)

    setShowGlobalResponseLoader(false)
    
    if(!updatedAgencyResponse.success) {
      setNotification({ msg: 'Erreur lors de la mise à jour de l\'agence.', type: 'error' })
      return
    }
    setAgency(updatedAgencyResponse.data)
  }

  return {
    isTemplateValidationRequired,
    toggleTemplateValidationRequirement,
    setTemplatesValidationRequired,
    updateAgency
  }
}

export default useAgencyActions
